export default __webpack_public_path__ + "static/media/Eric Medina.991c0f4f.png";